<div class="page-body">
  <div *ngIf="!loading && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">Noe gikk galt.</p>
      <p class="info-text">
        Prøv å laste inn siden på nytt ellers prøv igjen senere.
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="error-button"
          text="Tilbake"
          (click)="handleCancellation()"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="banner">
      <button type="button" class="back-button" (click)="handleBackClick()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tilbake</span>
      </button>
    </div>

    <!-- Form to answer kalp questions. -->
    <div *ngIf="!viewReviewAnswers && kalpQuestions" class="contents-wrapper">
      <div class="contents-container">
        <form [formGroup]="formGroup" novalidate>
          <zaver-stepper [shouldHideDefaultButtons]="true">
            <!-- STEP 1 -->
            <ng-template #step let-index>
              <div>
                <div class="step-heading">
                  Noen raske spørsmål før vi går videre
                </div>

                <p class="step-sub-heading">
                  For å gi en presis indikasjon på om du kan betale senere eller
                  dele opp et beløp på
                  {{
                    state.totalCheckoutValue?.amount
                      | currency: 'kr ':'code':'1.0-0':'sv'
                  }}, trenger vi å vite mer om din betalingsevne.
                </p>
              </div>
            </ng-template>

            <!-- STEP 2 -->
            <ng-template
              *ngIf="getShouldAskQuestion('LEQ_ANSWER_NET_MONTHLY_INCOME')"
              #step
              let-index
            >
              <div>
                <div class="step-heading">
                  Hva er årsinntekten din etter skatt?
                </div>
                <div class="form-input-container">
                  <zaver-animated-form-input
                    formControlName="monthlyNetIncome"
                    [error]="
                      formGroup.controls.monthlyNetIncome.invalid && showError
                    "
                    ariaLabel="Angi beløp"
                    placeholder="Angi beløp"
                    errorMessage="Vennligst skriv inn et tall mellom 0 og 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 3 -->
            <ng-template
              *ngIf="getShouldAskQuestion('LEQ_ANSWER_NUMBER_OF_ADULTS')"
              #step
              let-index
            >
              <div>
                <div class="step-heading">
                  Er du den eneste voksne i husholdningen?
                </div>
                <div class="pill-selector">
                  <zaver-pill
                    text="Ja"
                    [isSelected]="hasInherent"
                    (click)="hasInherent = true"
                  >
                  </zaver-pill>
                  <zaver-pill
                    text="Nei"
                    [isSelected]="!hasInherent"
                    (click)="hasInherent = false"
                  >
                  </zaver-pill>
                </div>
              </div>
            </ng-template>

            <!-- STEP 4 -->
            <ng-template
              *ngIf="getShouldAskQuestion('LEQ_ANSWER_NUMBER_OF_KIDS')"
              #step
              let-index
            >
              <div>
                <div class="step-heading">
                  Har du barn under 18 som bor hjemme?
                </div>
                <div class="pill-selector">
                  <zaver-pill
                    text="Ja"
                    [isSelected]="hasChildren"
                    (click)="hasChildren = true"
                  >
                  </zaver-pill>
                  <zaver-pill
                    text="Nei"
                    [isSelected]="!hasChildren"
                    (click)="hasChildren = false"
                  >
                  </zaver-pill>
                </div>
                <div *ngIf="hasChildren" class="form-input-container">
                  <div class="input-text">Hvor mange barn?</div>
                  <zaver-animated-form-input
                    formControlName="numberOfChildren"
                    [error]="
                      formGroup.controls.numberOfChildren.invalid && showError
                    "
                    ariaLabel="Angi antall barn"
                    placeholder="Angi antall barn"
                    errorMessage="Vennligst skriv inn et tall mellom 0 og 50"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                  ></zaver-animated-form-input>
                </div>
              </div>
            </ng-template>

            <!-- STEP 5 -->
            <ng-template
              *ngIf="getShouldAskQuestion('LEQ_ANSWER_TYPE_OF_HOUSING')"
              #step
              let-index
            >
              <div>
                <div class="step-heading">Hva slags bolig har du?</div>
                <div class="pill-selector">
                  <zaver-pill-selector
                    [(selectedOption)]="selectedHousingTypeOption"
                    [options]="housingTypeOptions"
                  ></zaver-pill-selector>
                </div>
                <div class="form-input-container">
                  <div class="input-text">
                    Hvor mye koster boliglånet ditt hver måned?
                  </div>
                  <zaver-animated-form-input
                    formControlName="monthlyMortgageCost"
                    [error]="
                      formGroup.controls.monthlyMortgageCost.invalid &&
                      showError
                    "
                    ariaLabel="Angi beløp"
                    placeholder="Angi beløp"
                    errorMessage="Vennligst skriv inn et tall mellom 0 og 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>
          </zaver-stepper>
        </form>

        <div class="footer-container">
          <zaver-basic-button
            class="step-back-button"
            text="Tilbake"
            [secondary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleBackClick()"
          >
          </zaver-basic-button>

          <zaver-basic-button
            text="Neste"
            [primary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleCtaClick()"
          >
          </zaver-basic-button>
        </div>
      </div>
    </div>

    <!-- VIEW REVIEW (Same as the review page) -->
    <div *ngIf="viewReviewAnswers && kalpAnswers" class="contents-wrapper">
      <div class="contents-container">
        <app-leq-summary-no
          class="leq-summary"
          [kalpAnswers]="kalpAnswers"
        ></app-leq-summary-no>

        <div class="footer-container">
          <zaver-basic-button
            class="update-button"
            text="Endre svar"
            [secondary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleUpdateClick()"
          >
          </zaver-basic-button>

          <zaver-basic-button
            text="Neste"
            [primary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleCtaClickReview()"
          >
          </zaver-basic-button>
        </div>
      </div>
    </div>
  </div>
</div>
